/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-02-16 08:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { FieldArray } from 'redux-form';
import AttributesTable from 'src/components/views/merchandising-v2/rule/strategy/attributes/attributes-table';
import { Button, TextStyle } from '@shopify/polaris';
import { DeleteMinor } from '@shopify/polaris-icons';

type Props = {};

type ComposedProps = Props & WithI18nProps;

class Attribute extends Component<ComposedProps> {

  constructor() {
    super();
    this.selectedIndexRef = React.createRef();
  }
  render() {
    const rowConditions = this.buildRows();
    return <div ref={this.parentRef}>{rowConditions.map(row => row)}</div>;
  }

  scrollIfNeeded(element, container) {
    if (element.offsetTop < container.scrollTop) {
      container.scrollTop = element.offsetTop;
    } else {
      const offsetBottom = element.offsetTop + element.offsetHeight;
      const scrollBottom = container.scrollTop + container.offsetHeight;
      if (offsetBottom > scrollBottom) {
        container.scrollTop = offsetBottom - container.offsetHeight;
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { parentRef } = this.props;
    if (
      this.props.selectedIndex !== prevProps.selectedIndex &&
      this.selectedIndexRef && this.selectedIndexRef.current &&
      parentRef && parentRef.current
    ) {
      this.scrollIfNeeded(this.selectedIndexRef.current, parentRef.current)
      this.selectedIndexRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest'})
    }
  }

  // Render rows for data table
  buildRows = () => {
    const {
      i18n,
      fields,
      type,
      strategies,
      options,
      appLanguage,
      updateField,
      collections,
      ruleType,
      selectedIndex,
      renderPreview,
      maxCondition
    } = this.props;

    const filterStrategyByType = strategies.filter(e => e.type === type);
    let countField = 0;
    const rows = fields
      .map((condition, index) => {
      // Get product attribute
      const attributes = _.get(strategies, `[${index}].attributes`, [{}]);
      const isSelected = selectedIndex === JSON.stringify(strategies[index]);

      if (
        _.get(strategies, `[${index}].type`, '') === type ||
        _.isEmpty(_.get(strategies, `[${index}].type`, ''))
      ) {
        countField++;
        const reachMaxCondition = countField >= maxCondition;
        return (
          <>
            <div className="wrap-attribute">
              <div className={`or-connector ${reachMaxCondition ? 'last-or-connector' : ''}`}></div>
              <div
                className="card-section"
                ref={isSelected ? this.selectedIndexRef : null}
                style={{
                  backgroundColor: `${
                    isSelected ? '#F6F6F7' : '#FFFFFF'
                  }`
                }}
                key={index}>
                <div className="consequence-detail-title tile-set-condition">
                  <div className="title">
                    <div className='group-number'>{countField}</div>
                    <TextStyle variation="subdued">
                    <span style={{ textTransform: 'uppercase' }}>
                      {i18n.translate('AdminHTML.MerchandisingV2.Rule.card3_Title', { t1: '' })}
                    </span>
                    </TextStyle>
                  </div>
                  {filterStrategyByType.length > 1 ? (
                    <Button icon={DeleteMinor} plain onClick={() => this.removeSet(index)}></Button>
                  ) : (
                    ''
                  )}
                </div>
                <FieldArray
                  name={`strategies[${index}].attributes`}
                  component={AttributesTable}
                  attributes={attributes}
                  type={type}
                  ruleType={ruleType}
                  key={index}
                  strategiesIndex={index}
                  options={options}
                  appLanguage={appLanguage}
                  updateField={updateField}
                  collections={collections}
                  renderPreview={renderPreview}
                />
              </div>
            </div>
            {!reachMaxCondition && (
              <div className='or-text'>
                <TextStyle variation='strong'>
                  {i18n.translate('AdminHTML.MerchandisingV2.Constant.condition_Or').toUpperCase()}
                </TextStyle>
              </div>
            )}
          </>
        );
      }
      return null;
    });

    return rows;
  };
  removeSet = index => {
    const { fields } = this.props;
    fields.remove(index);

    // Render preview
    // renderPreview('attributes-table removeSet()');
  };
}

export default withI18n()(Attribute);
